<template>
    <div>
        <block v-if="loading"></block>
        <div class="background rounded-lg pl-3 pr-3">
            <br/>
            <v-row class="mb-4" align="center">
                <v-col cols="12" md="12">
                    <v-card>
                        <v-card-title class="text-h5">
                            Nombre del archivo: {{ fileName ? fileName : 'No se ha cargado ningún archivo' }}
                        </v-card-title>
                        <v-card-text style="color: black;">
                            Registros generados: {{ importedRows.length }}    
                        </v-card-text>
                        <v-card-actions>
                            <v-btn class="btn-save" @click="triggerFileInput">
                                CARGAR ARCHIVO EXCEL
                            </v-btn>
                            <input
                                ref="fileInput"
                                type="file"
                                accept=".xls,.xlsx"
                                class="d-none"
                                @change="handleFileChange"
                            />
                            &nbsp;&nbsp;
                            <v-btn class="btnclean" @click="cleanData">
                                LIMPIAR
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>

            <v-row class="mb-4">
                <v-col cols="12">
                    <v-btn
                        class="btn-save btn-wrap-text"
                        :disabled="selectedRowKeys.length === 0"
                        @click="openCreateInvoiceModal"
                    >
                        CREAR FACTURA A PARTIR DE ELEMENTOS SELECCIONADOS
                    </v-btn>
                </v-col>
            </v-row>

            <v-row class="mb-2">
                <v-col cols="12" md="3">
                    <v-text-field
                        v-model="filters.lin_aerea"
                        outlined
                        dense
                        label="Línea aérea"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field
                        v-model="filters.boleto"
                        outlined
                        dense
                        label="Boleto"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field
                        v-model="filters.pasajero"
                        outlined
                        dense
                        label="Pasajero"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field
                        v-model="filters.ruta"
                        outlined
                        dense
                        label="Ruta"
                    ></v-text-field>
                </v-col>
            </v-row>

            <DxDataGrid
                ref="mainGrid"
                :data-source="filteredImportedRows"
                key-expr="uuid"
                :show-borders="true"
                :hover-state-enabled="true"
                :column-auto-width="true"
                :selected-row-keys="selectedRowKeys"
                :paging="{ enabled: false }"
                :scrolling="{ useNative: true }"
                style="max-height: 600px;"
                @selection-changed="onSelectionChanged"
            >
                <DxSelection mode="multiple" show-check-boxes-mode="always" />
                <DxColumn
                    data-field="usedInReadyToBill"
                    caption="Factura creada"
                    :calculate-cell-value="(row) => row.usedInReadyToBill ? 'SI' : 'NO'"
                    width="100"
                />
                <DxColumn data-field="item" caption="Item" width="90" />
                <DxColumn data-field="lin_aerea" caption="Línea aérea" />
                <DxColumn data-field="boleto" caption="Boleto" />
                <DxColumn data-field="pasajero" caption="Pasajero" />
                <DxColumn data-field="ruta" caption="Ruta" />
                <DxColumn data-field="punitario" caption="P. Unitario" />
                <DxColumn data-field="descuento" caption="Descuento" />
                <DxColumn data-field="exentas" caption="Exentas" />
                <DxColumn data-field="nosujetas" caption="No sujetas" />
                <DxColumn data-field="otrnsujeto" caption="Otr. no sujeto" />
                <DxColumn data-field="gravado" caption="Gravado" />
                <DxColumn data-field="iva" caption="IVA" />
            </DxDataGrid>
        </div>

        <v-dialog v-model="showCreateInvoiceModal" scrollable max-width="80%">
            <v-card>
                <v-card-title>
                    CREAR FACTURA A PARTIR DE ELEMENTOS SELECCIONADOS
                </v-card-title>
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" md="3">
                            <date-picker
                                label="Fecha"
                                :value="form.date"
                                @dateSelected="(value) => { form.date = value; }"
                                dense
                            >
                            </date-picker>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-select
                                v-model="form.invoiceType"
                                outlined
                                dense
                                label="Tipo de Factura"
                                :items="filterType"
                                item-text="name"
                                item-value="key"
                            ></v-select>
                        </v-col>
                        <!--v-col cols="12" md="3">
                            <v-select
                                v-model="form.invoiceStatus"
                                :items="checkCountryInvoiceStatuses"
                                outlined
                                dense
                                label="Estado de la Factura"
                            ></v-select>
                        </v-col-->
                        <v-col cols="12">
                            <CustomAutoComplete
                                style="display: inline-block; width: calc(100%); vertical-align: top;"
                                key="Customer"
                                v-if="customersList.length > 0"
                                :label="'Cliente'"
                                v-model="form.idcustomer"
                                :search="{ ...search, filteredFrom: 2 }"
                                :items="customersList"
                                :item-text="'itemText'"
                                :filter-endpoint="$API.customers.filterCustomers"
                                :item-value="'ID_Customer'"
                                @select="
                                    (e) => {
                                        form.idcustomer = e;
                                        customerSelectOnchange(e);
                                    }
                                "
                                @updateItems="updateCustomersList"
                            />
                        </v-col>
                    </v-row>

                    <DxDataGrid
                        :data-source="selectedRows"
                        key-expr="uuid"
                        :show-borders="true"
                        :hover-state-enabled="true"
                        :column-auto-width="true"
                        :paging="{ enabled: false }"
                        :scrolling="{ useNative: true }"
                        style="max-height: 400px;"
                    >
                        <DxColumn cell-template="remove-row" caption="" width="90" />
                        <template #remove-row="{ data }">
                            <v-btn
                                small
                                color="error"
                                class="white--text"
                                @click="removeSelectedRow(data.data.uuid)"
                            >
                                REMOVER
                            </v-btn>
                        </template>
                        <DxColumn data-field="item" caption="Item" width="90" />
                        <DxColumn data-field="lin_aerea" caption="Línea aérea" />
                        <DxColumn data-field="boleto" caption="Boleto" />
                        <DxColumn data-field="pasajero" caption="Pasajero" />
                        <DxColumn data-field="ruta" caption="Ruta" />
                        <DxColumn data-field="punitario" caption="P. Unitario" />
                        <DxColumn data-field="descuento" caption="Descuento" />
                        <DxColumn data-field="exentas" caption="Exentas" />
                        <DxColumn data-field="nosujetas" caption="No sujetas" />
                        <DxColumn data-field="otrnsujeto" caption="Otr. no sujeto" />
                        <DxColumn data-field="gravado" caption="Gravado" />
                        <DxColumn data-field="iva" caption="IVA" />
                    </DxDataGrid>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="btn-save" @click="createReadyToBill">
                        CREAR EN LISTO PARA FACTURAR
                    </v-btn>
                    <v-btn class="btndisable" @click="closeCreateInvoiceModal">
                        CANCELAR
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <alerts style="z-index: 20000 !important;"
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            :properties="alert"
            >
        </alerts>
    </div>
</template>

<script>
import Vue from "vue";
import * as XLSX from "xlsx";
import { DxDataGrid, DxColumn, DxSelection } from "devextreme-vue/data-grid";
import CustomAutoComplete from "../../components/CustomAutoComplete.vue";
import DatePicker from "../../components/DatePicker";
import { generateUUID } from "../../helpers/misc";
import Alerts from "@/components/Alerts";
import Block from "@/components/Block";

export default {
    name: "ImportAirlineTickets",
    components: {
        DxDataGrid,
        DxColumn,
        DxSelection,
        CustomAutoComplete,
        DatePicker,
        Alerts,
        Block
    },
    props: ["win"],
    data() {
        return {
            fileName: "",
            importedRows: [],
            filters: {
                lin_aerea: "",
                boleto: "",
                pasajero: "",
                ruta: ""
            },
            selectedRowKeys: [],
            showCreateInvoiceModal: false,
            customersList: [],
            invoiceTypeOptions: [],
            invoiceStatusOptions: [],
            form: {
                idcustomer: null,
                invoiceType: null,
                invoiceStatus: null,
                date: ""
            },
            search: {
                business: JSON.parse(localStorage.getItem("user")).businessid,
                branch: JSON.parse(localStorage.getItem("user")).branch,
            },
            loading: false,
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
        };
    },
    computed: {
        filteredImportedRows() {
            const lineAereaFilter = this.filters.lin_aerea.toLowerCase().trim();
            const boletoFilter = this.filters.boleto.toLowerCase().trim();
            const pasajeroFilter = this.filters.pasajero.toLowerCase().trim();
            const rutaFilter = this.filters.ruta.toLowerCase().trim();

            return this.importedRows.filter((row) => {
                const lineAerea = (row.lin_aerea || "").toString().toLowerCase();
                const boleto = (row.boleto || "").toString().toLowerCase();
                const pasajero = (row.pasajero || "").toString().toLowerCase();
                const ruta = (row.ruta || "").toString().toLowerCase();

                return lineAerea.includes(lineAereaFilter)
                    && boleto.includes(boletoFilter)
                    && pasajero.includes(pasajeroFilter)
                    && ruta.includes(rutaFilter);
            });
        },
        selectedRows() {
            return this.importedRows.filter((row) =>
                this.selectedRowKeys.includes(row.uuid)
            );
        },
        filterType() {
            return [
                {
                    name: "CONSUMIDOR FINAL",
                    key: "FCF"
                },
                {
                    name: "CRÉDITO FISCAL",
                    key: "CCF"
                }
            ]
        },
    },
    mounted() {
        this.getAllCostumers();
    },
    methods: {
        async closeAlert() {
            this.alert.show = false;

            if (this.alert.options == "update") {
                this.cleanForm() 
            }
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        cleanData() {
            this.fileName = ""
            this.importedRows = []
            this.filters = {
                lin_aerea: "",
                boleto: "",
                pasajero: "",
                ruta: ""
            }
            this.selectedRowKeys = []
        },
        cleanForm() {
            const hoy = new Date();
            const dia = String(hoy.getDate()).padStart(2, '0');
            const mes = String(hoy.getMonth() + 1).padStart(2, '0');
            const anio = hoy.getFullYear();

            const fecha = `${dia}/${mes}/${anio}`;

            this.form = {
                idcustomer: null,
                invoiceType: null,
                invoiceStatus: null,
                date: fecha
            }
        },
        triggerFileInput() {
            this.loading = true
            this.$refs.fileInput.click();
        },
        async handleFileChange(event) {
            const file = event.target.files && event.target.files[0];

            if (!file) {
                return;
            }

            this.fileName = file.name;

            try {
                const workbook = await this.readWorkbook(file);
                const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
                const rows = XLSX.utils.sheet_to_json(firstSheet, { defval: 0 });

                this.importedRows = this.transformRows(rows);
                this.filters = {
                    lin_aerea: "",
                    boleto: "",
                    pasajero: "",
                    ruta: ""
                }
                this.selectedRowKeys = [];
                this.showCreateInvoiceModal = false;
                this.showAlert("success", "Éxito", "Los datos del archivo adjunto se han cargado satisfactoriamente.")
            } catch (error) {
                this.fileName = "";
                this.importedRows = [];
                this.filters = {
                    lin_aerea: "",
                    boleto: "",
                    pasajero: "",
                    ruta: ""
                }
                this.selectedRowKeys = [];
                this.showCreateInvoiceModal = false;
                this.$toasted.error("Ocurrió un error al procesar el archivo Excel");
                this.showAlert("warning", "Advertencia", "Ocurrió un error al procesar el archivo adjunto.")
            } finally {
                this.loading = false
                event.target.value = null;
            }
        },
        readWorkbook(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = (e) => {
                    try {
                        const data = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(data, { type: "array" });
                        resolve(workbook);
                    } catch (error) {
                        reject(error);
                    }
                };

                reader.onerror = (error) => reject(error);
                reader.readAsArrayBuffer(file);
            });
        },
        transformRows(rows) {
            const taxableFields = ["exentas", "nosujetas", "otrnsujeto", "gravado"];

            return rows.reduce((accumulator, currentRow) => {
                const normalizedRow = this.normalizeRow(currentRow);
                const positiveFields = taxableFields.filter(
                    (field) => this.toNumber(normalizedRow[field]) > 0
                );

                if (positiveFields.length === 0) {
                    accumulator.push(this.buildRowRecord(normalizedRow));
                    return accumulator;
                }

                positiveFields.forEach((field) => {
                    const rowRecord = this.buildRowRecord(normalizedRow);

                    taxableFields.forEach((taxableField) => {
                        rowRecord[taxableField] = taxableField === field
                            ? this.toNumber(normalizedRow[taxableField])
                            : 0;
                    });
                    rowRecord.iva = field === "gravado"
                        ? this.toNumber(normalizedRow.iva)
                        : 0;

                    accumulator.push(rowRecord);
                });

                return accumulator;
            }, []);
        },
        normalizeRow(row) {
            return {
                item: row.item || "",
                lin_aerea: row.lin_aerea || "",
                boleto: row.boleto || "",
                pasajero: row.pasajero || "",
                ruta: row.ruta || "",
                punitario: this.toNumber(row.punitario),
                descuento: this.toNumber(row.descuento),
                exentas: this.toNumber(row.exentas),
                nosujetas: this.toNumber(row.nosujetas),
                otrnsujeto: this.toNumber(row.otrnsujeto),
                gravado: this.toNumber(row.gravado),
                iva: this.toNumber(row.iva)
            };
        },
        buildRowRecord(row) {
            return {
                uuid: generateUUID(),
                usedInReadyToBill: false,
                item: row.item,
                lin_aerea: row.lin_aerea,
                boleto: row.boleto,
                pasajero: row.pasajero,
                ruta: row.ruta,
                punitario: row.punitario,
                descuento: row.descuento,
                exentas: row.exentas,
                nosujetas: row.nosujetas,
                otrnsujeto: row.otrnsujeto,
                gravado: row.gravado,
                iva: row.iva
            };
        },
        toNumber(value) {
            if (typeof value === "number") {
                return value;
            }

            if (value === null || value === undefined || value === "") {
                return 0;
            }

            const sanitizedValue = value.toString().replace(/,/g, "").trim();
            const parsedValue = parseFloat(sanitizedValue);

            return isNaN(parsedValue) ? 0 : parsedValue;
        },
        onSelectionChanged(event) {
            const visibleKeys = this.filteredImportedRows.map((row) => row.uuid);
            const hiddenSelectedKeys = this.selectedRowKeys.filter((key) => !visibleKeys.includes(key));
            const visibleSelectedKeys = event.selectedRowKeys || [];

            this.selectedRowKeys = [...new Set([...hiddenSelectedKeys, ...visibleSelectedKeys])];

            if (this.selectedRowKeys.length === 0) {
                this.showCreateInvoiceModal = false;
            }
        },
        openCreateInvoiceModal() {
            if (this.selectedRowKeys.length === 0) {
                return;
            }

            this.showCreateInvoiceModal = true;
        },
        closeCreateInvoiceModal() {
            this.showCreateInvoiceModal = false;
        },
        removeSelectedRow(uuid) {
            this.selectedRowKeys = this.selectedRowKeys.filter((key) => key !== uuid);

            if (this.$refs.mainGrid && this.$refs.mainGrid.instance) {
                this.$refs.mainGrid.instance.deselectRows([uuid]);
            }

            if (this.selectedRowKeys.length === 0) {
                this.showCreateInvoiceModal = false;
            }
        },
        createReadyToBill() {
            this.showCreateInvoiceModal = false;
            this.loading = true;
            const selectedItems = this.importedRows.filter((row) => 
                this.selectedRowKeys.includes(row.uuid)
            );

            let obj = []

            //Preparando datos para el endpoint
            selectedItems.map((data) => {
                let priceToUse = data.punitario
                let desc = 0.0
                let iva = 0.0
                
                if (data.gravado > 0) {
                    desc = parseFloat(((data.descuento / priceToUse) * 100).toFixed(8))

                    if (this.form.invoiceType == "FCF") {
                        priceToUse = data.gravado + data.iva
                    }

                    if (this.form.invoiceType == "CCF") {
                        priceToUse = data.gravado
                    }

                    iva = data.iva
                }
                
                if (data.nosujetas > 0 || data.exentas > 0 || data.otrnsujeto > 0) {
                    desc = 0.0
                    priceToUse = data.nosujetas || data.exentas || data.otrnsujeto
                }

                obj.push({
                    idbranch: this.search.branch,
                    idbusiness: this.search.business,
                    iditem: 'TICKETAIRLINE', 
                    itemtype: 'service',
                    itemquantity: 1,
                    itemmeasureunit: 'Unidades',
                    itemdescription: data.lin_aerea + " " + data.boleto + " " + data.pasajero + " " + data.ruta,
                    itemunitcost: priceToUse || 0, //Precio unitario original sin aplicar el descuento y con el iva
                    itemdiscount: data.descuento || 0, //el.discountFixed || 0, //descu || 0,
                    itemdiscountpercent: desc || 0,
                    itemnosuj: data.nosujetas, //No debe de incluir el iva ni el descuento
                    itemexenta: data.exentas, //No debe de incluir el iva ni el descuento
                    itemnogravada: data.otrnsujeto,
                    itemgravada: priceToUse, //No debe de incluir el iva ni el descuento
                    itempsv: priceToUse,
                    itemiva: iva,
                    itemcurrency: "$",
                    warehouse: "",
                    itembatch: "",
                    ishidrocarburo: 0,
                    principalbarcode: "",
                    turismoporalojamiento: 0,
                    itemcomments: "",//"agregado desde importación de boletos de avión",
                    pricelistname: null,
                    LineaAerea: data.lin_aerea || null,
                    Boleto: data.boleto || null,
                    Pasajero: data.pasajero || null,
                    Ruta: data.ruta || null, 
                })
            })

            let invoice = {
                invoicedate: this.form.date || "",
                invoicetype: this.form.invoiceType || "",
                idcustomer: this.form.idcustomer || "",
                invoicename: this.form.legalname || "",
                invoiceaddress: this.form.legaladdress || "",
                invoicenrc: this.form.legalnrc || "",
                invoicenit: this.form.legalnit || "",
                invoicedui: this.form.dui || "",
                invoicesector: this.form.legalsector || "",
                invoiceentity: this.form.legalentity || "",
                invoicepaymenttype: "",
                invoicetaxpayersize: this.form.legaltaxpayersize || "",
                invoiceisnontaxable: this.form.legalisnontaxable || 0,
                invoicecurrency: "$",
                invoiceinternalnote: "",
                invoicestatus: 0,
                invoicestatusdescription: "",
                invoicecreditday: 0,
                invoicereference: "",
                invoicetotalnosuj: 0.0,
                invoicetotalgravada: 0.0,
                invoicesubtotalventas: 0.0,
                invoicedescunosuj: 0.0,
                invoicedescuexenta: 0.0,
                invoicedescugravada: 0.0,
                invoiceporcentajedescuento: 0.0,
                invoicetotaldescu: 0.0,
                invoicesubtotal: 0.0,
                invoiceivaperce1: 0.0,
                invoiceivarete1: 0.0,
                invoicereterenta: 0.0,
                invoicemontototaloperacion: 0.0,
                invoicetotalnogravada: 0.0,
                invoicetotalexenta: 0.0,
                invoicetotalpagar: 0.0,
                invoicetotaliva: 0.0,
                invoicetotalletras: "",
                idbranch: this.search.branch,
                idbusiness: this.search.business,
                isglobalbranch: false,
                ID_Seller: "",
                MoneyReturn: 0,
                zoneclient: "",
                stockproductsinreserve: 0,
                turismoporalojamiento: 0,
                CheckTurismoPorAlojamiento: 0,
                CheckPriceWithoutIvaCCF: this.form.invoiceType == 'CCF' ? 1 : 0,
                InventoryStatus: 0,
                ventaterceronit: null,
                ventaterceronombre: null,
                invoiceaddress2: null,
                propina: 0,
                ID_Technical: null 
            }

            this.$API.invoices.createInvoice({
                header: invoice,
                items: obj,
                user: JSON.parse(localStorage.getItem("user")).id,
                invalid: null,
                ndornc: null,
                contingency: null,
                UseReserveWarehouse: JSON.parse(localStorage.getItem("user")).usereservewarehouse || 0,
                ShowCorrelativeControl: JSON.parse(localStorage.getItem("user")).showcorrelativecontrol || 0,
                UseNewSpNumControl: JSON.parse(localStorage.getItem("user")).usenewspnumcontrol || 0,
                ServicioDeProPinas: null
            })
            .then(async (resp) => {
                if (resp?.success) {
                    let response = resp.data

                    if (response.sendBill == 0) {
                        const usedRowKeys = selectedItems.map((row) => row.uuid);

                        this.importedRows = this.importedRows.map((row) => ({
                            ...row,
                            usedInReadyToBill: usedRowKeys.includes(row.uuid)
                                ? true
                                : row.usedInReadyToBill
                        }));
                        this.selectedRowKeys = [];

                        this.showAlert(
                            "success",
                            "Factura generada",
                            response.message,
                            "update",
                        );
                    } else {
                        let message = "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)";
                        this.showAlert("warning", "Advertencia", message);
                    }
                } else if (!resp?.success) {
                    let response = resp.data
                    
                    if (resp?.lockdata) {
                      let message = "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)"
                      this.showAlert("warning", "Información", message);
                    }
                    else if (resp?.typeError == "InventoryError") {
                      let message = 'No se puede crear el comprobante, se encontraron los siguientes errores: <br/><br/> '
                      message += typeof response === 'string' ? response : response?.message ?? '';
                      this.showAlert("dangerHtml", "Advertencia", message)
                    }
                    else if (response?.typeError == "DteError") {
                      let message = `Ha ocurrido un problema al momento de generar el correlativo del número de control, el sistema ha procedido a hacer la corrección en este momento.
                        <br/><br/>
                        Favor hacer clic nuevamente en Facturar para enviar el documento tributario electrónico`
                      
                      this.showAlert("dangerHtml", "Advertencia", message)
                    }
                    else {
                      let message = response.message || "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)"
                      this.showAlert("warning", "Advertencia", message);
                    }
                  }
            })
            .catch(() => {
                let message = "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)"
                this.showAlert("warning", "Advertencia", message);
            }) 
            .finally(() => {
                this.loading = false
            })
        },
        async getAllCostumers() {
            try {
                const customers =
                    await this.$API.customers.getCustomersPOSCreateInvoice(this.search);
                this.customersList = this.assignCustomersList(customers);
            } catch (error) {
                this.$toasted.error(
                    "Ha ocurrido un error al intentar obtener los clientes"
                );
            }
        },
        assignCustomersList(customers) {
            return customers.map((current) => {
                if (current.Is_a_business) {
                    current.itemText = current.BusinessName;
                } else {
                    current.itemText = current.LegalName;
                }

                return current;
            });
        },
        updateCustomersList(payload) {
            this.customersList = this.assignCustomersList(payload);
        },
        async customerSelected(data) {
            if (
                !this.customersList.find(
                    (current) => current.ID_Customer === data.ID_Customer
                )
            ) {
                if (data.Is_a_business) {
                    data.itemText = data.BusinessName;
                } else {
                    data.itemText = data.LegalName;
                }

                this.customersList.push(data);
            }

            Object.keys(data).map((key) => {
                Vue.set(this.form, key.replace("_", "").toLowerCase(), data[key]);
            });

            if (data.Is_a_Table) {
                this.form.legalname = "CLIENTES VARIOS";
            }

            if (this.form.dui) {
                this.form.dui = this.form.dui.replace("-", "");
            }

            if (this.form.legalnrc) {
                this.form.legalnrc = this.form.legalnrc.replace("-", "");
            }

            if (this.form.legalnit) {
                this.form.legalnit = this.form.legalnit.replace("-", "");
            }
        },
        async customerSelectOnchange(event) {
            try {
                const foundCustomer = this.customersList.find(
                    (current) => current.ID_Customer === event
                );

                if (foundCustomer) {
                    this.customerSelected(foundCustomer);
                }
            } catch (error) {
                this.$toasted.error(
                    `Ocurrió un error al intentar seleccionar un cliente ${error.message}`
                );
            }
        }
    }
};
</script>

<style scoped>
.btn-add{
    background-color: #00A178 !important;
    color: white;
}

.btnclean {
    background-color: #f29d35 !important;
    color: white;
}

.btnsave {
    background-color: #3498db !important;
    color: white;
}

.background {
    background: white !important;
    color: white;
}

.btn-wrap-text {
    padding: 10px 16px;
    width: fit-content;
    font-weight: 500;
    font-size: 0.875rem;
    align-items: center;
    border-radius: 4px;
    display: inline-flex;
    flex: 0 0 auto;
    letter-spacing: 0.0892857143em;
    justify-content: center;
    outline: 0;
    position: relative;
    text-decoration: none;
    text-indent: 0.0892857143em;
    text-transform: uppercase;
    transition-duration: 0.28s;
    transition-property: box-shadow, transform, opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
}

.btndisable {
  background-color: #41464c !important;
  color: white;
}

@media screen and (max-width: 521px) {
    .btn-wrap-text {
        text-align: center;
        line-height: 1.5;
        width: 100%;
    }
}
</style>
